import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn, formatCurrency, formatPercent } from '../../lib/utils';

export const KPICard = ({
  title,
  value,
  change,
  changeLabel,
  format = 'currency',
  icon: Icon,
  trend,
  status,
  className,
  onClick,
}) => {
  const getTrendIcon = () => {
    if (trend === 'up') return TrendingUp;
    if (trend === 'down') return TrendingDown;
    return Minus;
  };

  const getTrendColor = () => {
    if (status === 'good' || (trend === 'up' && !status)) return 'text-emerald-600 bg-emerald-50';
    if (status === 'bad' || (trend === 'down' && !status)) return 'text-red-600 bg-red-50';
    return 'text-slate-500 bg-slate-50';
  };

  const formatValue = () => {
    if (format === 'currency') return formatCurrency(value, { compact: true });
    if (format === 'percent') return formatPercent(value);
    if (format === 'number') return value?.toLocaleString('en-IN');
    if (format === 'months') return `${value} mo`;
    if (format === 'days') return `${value} days`;
    if (format === 'multiple') return `${value}x`;
    return value;
  };

  const TrendIcon = getTrendIcon();
  const trendColorClass = getTrendColor();

  return (
    <div
      className={cn(
        'kpi-card group cursor-pointer',
        className
      )}
      onClick={onClick}
      data-testid={`kpi-card-${title?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="kpi-label mb-1">{title}</p>
          <p className="kpi-value">{formatValue()}</p>
        </div>
        {Icon && (
          <div className="p-2 rounded-lg bg-primary-50 text-primary-700 group-hover:bg-primary-100 transition-colors">
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>

      {(change !== undefined || changeLabel) && (
        <div className="mt-4 flex items-center gap-2">
          <div className={cn('flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold', trendColorClass)}>
            <TrendIcon className="w-3 h-3" />
            <span>{formatPercent(Math.abs(change), { showSign: false })}</span>
          </div>
          {changeLabel && (
            <span className="text-xs text-slate-500">{changeLabel}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default KPICard;
